export enum VenueType {
    PUMP_FUN = 'PUMP_FUN',
    JUPITER = 'JUPITER',
    PUMP_SWAP = 'PUMP_SWAP',
    PUMP_UP = 'PUMP_UP',
}

const venueParamToEnumMap: Record<string, VenueType> = {
    'pump-fun': VenueType.PUMP_FUN,
    'jupiter': VenueType.JUPITER,
    'pump-swap': VenueType.PUMP_SWAP,
    'pump-up': VenueType.PUMP_UP,
};


export const resolveVenue = (param: string | undefined): VenueType | undefined => {
    if (!param) return undefined;
    return venueParamToEnumMap[param];
}